module.exports = require("graphql-nats-subscriptions");